import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

const SwannanoaValleyMigration = dynamic(() => import('./region-2-migration'), { ssr: false })

export const migrationPlugins: Record<number, ComponentType | undefined> = {
  2: SwannanoaValleyMigration,
}
